import React from 'react';
import { connect } from 'react-redux';

import classes from './BarVentasDeSucursalesPorSeleccion.css';

import { formatNumber } from '../../../../shared/formatNumber';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import Table from '../../../UI/Table/Table';
import { Tooltip } from '@material-ui/core';
import BarVentasDeSucursalesPorSeleccionInTableToExcel from './BarVentasDeSucursalesPorSeleccionInTableToExcel';

const BarVentasDeSucursalesPorSeleccionToTable = (props) => {
  const { ventasPor, datas, categories, fecha } = props;

  const columns = () => {
    const formatColumns = [
      {
        title: ventasPor,
        field: 'name',
        align: 'left',
        cellStyle: {
          fontSize: '12px',
          paddingBottom: '5px',
          paddingTop: '5px'
        },
        headerStyle: {
          fontSize: '14px',
          paddingTop: '0px',
          paddingBottom: '0px',
          backgroundColor: '#fafafa'
        }
      }
    ];

    datas.map((data) => {
      return formatColumns.push({
        title: data.name,
        field: data.name,
        align: 'right',
        type: 'numeric',
        cellStyle: (cellData) => {
          return {
            fontSize: '12px',
            paddingBottom: '5px',
            paddingTop: '5px',
            color: cellData < 0 && 'red'
          };
        },
        headerStyle: {
          fontSize: '14px',
          paddingTop: '0px',
          paddingBottom: '0px',
          backgroundColor: '#fafafa'
        },
        render: (rowData) => `${storageMonedaSigno()} ${formatNumber(rowData[data.name] ? rowData[data.name] : 0)}`
      });
    });

    return formatColumns;
  };

  const data = () => {
    const formatData = [];
    categories.map((categoria, categoriaIndex) => {
      let formatCategoria = {
        name: categoria
      };
      datas.map((vendedorMontos) => {
        return (formatCategoria = { ...formatCategoria, [vendedorMontos.name]: vendedorMontos.data[categoriaIndex] });
      });
      return formatData.push(formatCategoria);
    });

    return formatData;
  };

  return (
    <div className={classes.TablaVentasDeVendedoresPorSeleccionContainer}>
      <div className={classes.TitleCard}>
        <Tooltip title={'Exportar a excel'}>
          <BarVentasDeSucursalesPorSeleccionInTableToExcel
            datas={data()}
            columns={columns()}
            ventasPor={ventasPor}
            fecha={fecha}
          />
        </Tooltip>
      </div>
      <Table
        title=""
        columns={columns()}
        data={data()}
        noBoxShadow
        customOptions={{
          thirdSortClick: false,
          sorting: true,
          grouping: false,
          draggable: false,
          fixedColumns: true,
          layout: 'fixed',
          search: false,
          paging: false,
          toolbar: false,
          showTitle: false,
          maxBodyHeight: 600,
          rowStyle: (rowData) => ({
            color: rowData.tableData.monto < 0 && 'red'
          })
        }}
        tableKey={"tabla-bar-ventas-sucursales-seleccion-to-table"}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(BarVentasDeSucursalesPorSeleccionToTable);
